import {
  INQUISITIVE_FACEBOOK,
  INQUISITIVE_FACEBOOK_US,
  INQUISITIVE_INSTAGRAM,
  INQUISITIVE_INSTAGRAM_US,
} from 'global/constants';
import {
  FooterSocialLinkStyled,
  FooterSocialsGroupStyled,
} from 'approot/shared/layout/footer/footer.style';
import SocialInlineSvg from 'approot/shared/inline-svg/social/social-inline-svg';
import { useRegionData } from 'approot/shared/region/region.apollo';

const FooterSocials = () => {
  const { isRegionAU } = useRegionData();

  return (
    <FooterSocialsGroupStyled data-selector="social-header">
      <ul>
        <li>
          <FooterSocialLinkStyled
            href={isRegionAU ? INQUISITIVE_FACEBOOK : INQUISITIVE_FACEBOOK_US}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Inquisitive on Facebook"
          >
            <SocialInlineSvg id="icon_facebook" width="24" height="24" />
          </FooterSocialLinkStyled>
        </li>
        <li>
          <FooterSocialLinkStyled
            href={isRegionAU ? INQUISITIVE_INSTAGRAM : INQUISITIVE_INSTAGRAM_US}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Inquisitive on Instagram"
          >
            <SocialInlineSvg id="icon_instagram" width="24" height="24" />
          </FooterSocialLinkStyled>
        </li>
      </ul>
    </FooterSocialsGroupStyled>
  );
};

export default FooterSocials;
